<template>
    <div class="Complete">
        <div class="Complete-dv">
            <div class="Complete-dvh">
                <!-- <img src="../../assets/bg-xiangqing-lv.png" alt=""> -->
                <h1>问卷填写</h1>
            </div>
        </div>
        <div class="Complete-dv1">
            <h3>{{name}}</h3>
            <div class="Complete-tu">
                <!-- <img src="../../assets/img-wenjuan.png" alt=""> -->
                <div class="Complete_img">

                </div>
                <span>已完成问卷填写</span>
            </div>
            <div class="Complete-dv4" @click="clickbgc(index)" :class="{ active: isActive == index  }" v-for="(item,index) in list" :key="index">
                {{item}}
            </div>
        </div>
        
        <back-to :path="'/Questionnairefilling'"></back-to>
    </div>
</template>
<script>
import backTo from '@/components/back'
export default {
    components: { backTo },
    data(){
        return{
            name:this.$route.query.names,
            isActive:0,
            list:['查看问卷详情','未完成问卷']
        }
    },
    methods:{
        clickbgc(index){
            this.isActive = index
            if(index == 1){
                this.$router.push({path: '/myQuestionaire'})
            }else{ 
                 this.$router.push({path: "/Questionnairedetails",query:{formId:this.$route.query.formId,name:this.$route.query.names}})
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    .Complete{
        
        .Complete-dv{
            .Complete-dvh{
                width: 100%;
                height: 140px;
                background: url('../../assets/bg-xiangqing-lv.png') no-repeat center center;
                background-size: 100% 100%;
                h1{
                    position: absolute;
                    left: 50%; 
                    top: 55px; 
                    transform: translate(-50%, -50%);
                    font-size:36px;
                    font-family:PingFangSC;
                    font-weight:600;
                    color:rgba(255,255,255,1);
                    letter-spacing: 5px;
                }
                img{
                    width: 100%;
                    height: 140px;
                }
            }
        }
        .Complete-dv1{
            width: 100%;
            height: 91.5%;
            position: absolute;
            top: 110px;
            background:rgba(255,255,255,1);
            box-shadow:$box-shadow;
            border-radius:40px 40px 0px 0px;
            h3{
                font-size:30px;
                font-family:PingFangSC;
                font-weight:500;
                color:rgba(50,50,50,1);
                text-align: center;
                margin-top: 39px;
                margin-bottom: 59px;
            }
            .Complete-tu{
                text-align: center;
                .Complete_img{
                    width: 100%;
                    height: 300px;
                    background: url('../../assets/img-wenjuan.png') no-repeat center center;
                    background-size: 100% 100%;
                    margin-top: 180px;
                }
                span{
                    margin-top: 63px;
                    display: block;
                    margin-bottom: 60px;
                    font-size:30px;
                    font-family:PingFangSC;
                    font-weight:400;
                    color:rgba(142,233,202,1);
                }
            }
        }
        .Complete-dv3{
            position: fixed;
            bottom: 80px;
            left: 24px;
            img {
                width: 71px;
                height: 71px;
            }
        }
        .Complete-dv4{
            width:650px;
            height:100px;
            box-shadow:0px 0px 30px 0px rgba(156,233,200,0.6);
            border-radius:50px;
            margin: 0 auto;
            margin-bottom: 50px;
            text-align: center;
            color: #03B187;
            line-height: 100px;
        }
        .active{
            background:linear-gradient(90deg,rgba(142,233,202,1) 0%, rgba(3,177,135,1)100%);
            color: #fff;
        }
    }
</style>